module.exports = __webpack_public_path__ + "8a2fb936d31aa3be3f25b5baaa01b722.svg";